import React, { useState } from "react";
import Moment from "react-moment";
import PaymentDetailsModal from "../components/Modal/PaymentDetailsModal";
import { Link } from "react-router-dom";

const PaymentTable = ({ payments, loading }) => {
  const [selectedPayment, setSelectedPayment] = useState(null);

  return (
    <div className="rounded-lg border border-gray-200 overflow-scroll">
      <table className="w-full">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left">Payment ID</th>
            <th className="px-6 py-3 text-left">Date</th>
            <th className="px-6 py-3 text-left">User</th>
            <th className="px-6 py-3 text-left">Mobile</th>
            <th className="px-6 py-3 text-left">Amount</th>
            <th className="px-6 py-3 text-left">Method</th>
            <th className="px-6 py-3 text-left">Type</th>
            <th className="px-6 py-3 text-left">Status</th>
            <th className="px-6 py-3 text-left">UTR No</th>
            <th className="px-6 py-3 text-left">Details</th>
            <th className="px-6 py-3 text-left">Action</th>

          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {loading ? (
            <tr>
              <td colSpan={10} className="px-6 py-10 text-center">
                <div className="flex justify-center">
                  <div className="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                </div>
              </td>
            </tr>
          ) : payments?.length === 0 ? (
            <tr>
              <td colSpan={10} className="px-6 py-10 text-center text-gray-500">
                No payments found
              </td>
            </tr>
          ) : (
            payments.map((payment) => (
              <tr key={payment.paymentId}>
                <td className="border border-gray-300 px-4 py-2">{payment.paymentId}</td>
                <td className="border border-gray-300 px-4 py-2">
                  {payment.paymentDate && (
                    <Moment format="DD MMM YYYY hh:mm:ss A">
                      {payment.paymentDate}
                    </Moment>
                  )}
                </td>
                <td className="border border-gray-300 px-4 py-2">{payment.userName}</td>
                <td className="border border-gray-300 px-4 py-2">{payment.mobileNumber}</td>
                <td className="border border-gray-300 px-4 py-2">{payment.amount}</td>
                <td className="border border-gray-300 px-4 py-2">{payment.paymentMethod}</td>
                <td className="border border-gray-300 px-4 py-2">{payment.paymentType}</td>
                <td className="border border-gray-300 px-4 py-2">
                  <span
                    className={`px-2 py-1 rounded-full text-sm ${
                      payment.status.toUpperCase() === "SUCCESS"
                        ? "bg-green-100 text-green-800"
                        : payment.status.toUpperCase() === "PENDING"
                        ? "bg-yellow-100 text-yellow-800"
                        : "bg-red-100 text-red-800"
                    }`}
                  >
                    {payment.status.toUpperCase()}
                  </span>
                </td>
                <td className="border border-gray-300 px-4 py-2">{payment.utrNo || "N/A"}</td>
                <td className="border border-gray-300 px-4 py-2">
                  <button
                    onClick={() => setSelectedPayment(payment)}
                    className="px-4 py-2 border border-blue-600 rounded hover:bg-blue-50"
                  >
                    View Details
                  </button>
                </td>
                   <td className="border border-gray-300 px-4 py-2">
                              <Link
                      to={`/webhookLogs/${payment.paymentId}?type=payments`}
                      className="px-3 py-1 underline text-sm rounded-md "
                    >
                      Webhook Logs
                    </Link>
                              </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {selectedPayment && (
        <PaymentDetailsModal
          payment={selectedPayment}
          isOpen={!!selectedPayment}
          onClose={() => setSelectedPayment(null)}
        />
      )}
    </div>
  );
};

export default PaymentTable;
